var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 116,
    viewBox: "0 0 127 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1944 116C54.1944 107.426 56.0906 100.335 59.8831 94.7292C63.8404 89.1229 69.5291 82.9396 76.9492 76.1791C82.3905 71.2324 86.3479 67.1102 88.8212 63.8124C91.4595 60.3497 92.7786 56.4748 92.7786 52.1876C92.7786 46.0867 90.3052 41.3049 85.3586 37.8422C80.5767 34.2146 74.146 32.4008 66.0664 32.4008C58.3166 32.4008 51.3912 34.0497 45.2903 37.3475C39.3543 40.4804 34.3251 44.9325 30.2029 50.7036L0.275391 33.1429C7.20076 22.5899 16.517 14.4279 28.2242 8.65671C40.0963 2.88557 54.1119 0 70.2711 0C89.2335 0 104.403 4.0398 115.781 12.1194C127.323 20.199 133.094 31.4115 133.094 45.7569C133.094 52.5174 131.94 58.4534 129.631 63.565C127.488 68.6766 124.767 73.0462 121.469 76.6738C118.337 80.1365 114.214 84.1763 109.103 88.7932C103.002 94.2345 98.5497 98.8515 95.7466 102.644C92.9435 106.271 91.5419 110.724 91.5419 116H54.1944Z",
    fill: "#00AA63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenQuestionMark);
export default __webpack_public_path__ + "static/media/green-question-mark.93c1d22104f41acbd62f52839d913caf.svg";
export { ForwardRef as ReactComponent };